import React, { cloneElement } from 'react';
import {
  List,
  Show,
  Edit,
  Datagrid,
  TextField,
  SimpleForm,
  SimpleShowLayout,
  ShowButton,
  EditButton,
  CardActions,
  RefreshButton,
  translate,
  DateField,
  BooleanField,
  BooleanInput,
  ImageField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  FunctionField,
  Responsive,
  SimpleList,
  Filter,
  TextInput,
  resolveBrowserLocale,
  ListButton,
  Toolbar,
  SaveButton,
  DisabledInput
} from 'react-admin';
// import { PageTitle } from './common';
import { Title } from '../components/Title';

import { withStyles } from '@material-ui/core/styles';
import { Pagination } from 'react-admin';

const paginationEvent = 50;
const PostPagination = props => (
  <Pagination rowsPerPageOptions={[]} {...props} />
);

const EventsListActions = ({
  resource,
  filters,
  showFilter,
  displayedFilters,
  filterValues
}) => (
  <CardActions>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button'
      })}
    <RefreshButton />
  </CardActions>
);

const styles = {
  image: {
    width: 'auto',
    height: '100%',
    maxHeight: '3rem',
    objectFit: 'cover'
  }
};

const EventsFilter = props => {
  const { translate } = props;
  return (
    <Filter {...props}>
      <TextInput
        label={translate('resources.events.search')}
        // label="rechercher"
        source="searchQuery"
        alwaysOn
      />
    </Filter>
  );
};

// let EventTitle = ({ record, translate }) => (
//   <span>
//     {`${translate('resources.events.title', 1)}: `}
//     {record ? `${record.title}` : ''}
//   </span>
// );

const renderUsersNumber = ({ record, translate, ...rest }) => {
  if (record && record.users) {
    return record.users.length;
  }
  return '0';
};

let EventsList = props => {
  const locales = resolveBrowserLocale();
  const { translate, classes, options, ...rest } = props;
  const { roleLevel } = options;
  return (
    <Responsive
      xsmall={
        <List
          title={<Title />}
          // title={<PageTitle title={translate('resources.events.title', 2)} />}
          sort={{ field: 'startDate', order: 'DESC' }}
          actions={<EventsListActions />}
          bulkActionButtons={false}
          {...rest}
          filters={<EventsFilter translate={translate} />}
          //pagination={null}
        >
          <SimpleList
            linkType="show"
            //leftAvatar={record => record.imageUrl}
            primaryText={record => record.title}
            secondaryText={record => record.location}
            tertiaryText={record =>
              new Date(record.startDate).toLocaleDateString()
            }
            leftAvatar={record => (
              <ImageField
                source="imageUrl"
                title="thumbnail image"
                classes={classes}
                record={record}
              />
            )}
          />
        </List>
      }
      medium={
        <List
          title={<Title />}
          // title={<PageTitle title={translate('resources.events.title', 2)} />}
          actions={<EventsListActions />}
          bulkActionButtons={false}
          sort={{ field: 'startDate', order: 'DESC' }}
          filters={<EventsFilter translate={translate} />}
          perPage={paginationEvent}
          {...rest}
          pagination={<PostPagination />}
          //pagination={null}
        >
          <Datagrid>
            <TextField
              source="host"
              label={translate('resources.events.host')}
              // sortable={false}
            />
            <ImageField
              source="imageUrl"
              label={translate('resources.events.photo')}
              title="Miniature"
              classes={classes}
              sortable={false}
            />
            <TextField
              source="title"
              label={translate('resources.events.title', 1)}
              // sortable={false}
            />
            <TextField
              source="location"
              label={translate('resources.events.location')}
              // sortable={false}
            />
            <DateField
              source="startDate"
              label={translate('resources.events.start')}
              //sortable={false}
              locales={locales}
            />
            <BooleanField
              label={translate('resources.events.available')}
              source="isPlanned"
              //sortable={false}
            />
            <FunctionField
              label={translate('resources.users.participant', 2)}
              render={record => renderUsersNumber({ record, translate })}
              source="users"
            />
            <ShowButton />

            {roleLevel > 0 && <EditButton />}
          </Datagrid>
        </List>
      }
    />
  );
};

const renderUsers = ({ record, translate, ...rest }) => {
  if (record && record.users) {
    return (
      <ReferenceArrayField
        record={record}
        {...rest}
        basePath="/users"
        label={(translate('resources.users.name'), 1)}
        reference="users"
        source="users"
      >
        <SingleFieldList linkType="show">
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
    );
  }
  return translate('resources.users.no_user');
};

const EventsShowActions = ({ basePath, data, roleLevel }) => {
  return (
    <CardActions>
      {roleLevel > 0 && <EditButton basePath={basePath} record={data} />}
      <ListButton basePath={basePath} />
      <RefreshButton />
    </CardActions>
  );
};

let EventShow = ({ translate, options, ...rest }) => {
  const { roleLevel } = options;

  return (
    <Show
      // title={<EventTitle />}
      title={<Title />}
      actions={<EventsShowActions roleLevel={roleLevel} />}
      {...rest}
    >
      <SimpleShowLayout>
        <TextField source="title" />
        <TextField
          source="host"
          label={translate('resources.events.host')}
          sortable={false}
        />
        <BooleanField
          label={translate('resources.events.available')}
          source="isPlanned"
          sortable={false}
        />
        <TextField
          source="location"
          label={translate('resources.events.location')}
          sortable={false}
        />
        <DateField
          source="startDate"
          label={translate('resources.events.start')}
          sortable={false}
          options={{
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          }}
        />
        <DateField
          source="endDate"
          label={translate('resources.events.end')}
          sortable={false}
          options={{
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          }}
        />
        <ImageField
          source="imageUrl"
          label={translate('resources.events.photo')}
          title="title"
        />
        <TextField
          source="description"
          label={translate('resources.events.description')}
          sortable={false}
        />
        <FunctionField
          label={translate('resources.users.participant', 2)}
          render={record => renderUsers({ record, translate })}
        />
      </SimpleShowLayout>
    </Show>
  );
};

const EventsEditActions = ({ basePath, data, resource }) => {
  return (
    <CardActions>
      <ShowButton basePath={basePath} record={data} />
      <ListButton basePath={basePath} />
      <RefreshButton />
    </CardActions>
  );
};

const EventEditToolbar = ({ record, ...rest }) => {
  return (
    <Toolbar {...rest}>
      <SaveButton label="ENREGISTRER" redirect="show" submitOnEnter={true} />
    </Toolbar>
  );
};

let EventEdit = ({ translate, ...rest }) => (
  <Edit
    // title={<EventTitle />}
    title={<Title />}
    actions={<EventsEditActions />}
    {...rest}
  >
    <SimpleForm toolbar={<EventEditToolbar />}>
      <DisabledInput source="title" />
      <BooleanInput
        label={translate('resources.events.available')}
        source="isPlanned"
      />
    </SimpleForm>
  </Edit>
);

EventsList = translate(EventsList);
EventsList = withStyles(styles)(EventsList);
// EventTitle = translate(EventTitle);
EventShow = translate(EventShow);
EventEdit = translate(EventEdit);

export { EventsList, EventShow, EventEdit };



// WEBPACK FOOTER //
// ./src/components/Events.js